/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'agent/protection': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M12 7c0-1-1-2-2-2S8 6 8 7s.582 1.738 1.6 2C9 9 8 10 8 12v3h4v-3c0-2-1-3-1.6-3 1.051-.262 1.6-1 1.6-2z"/><path pid="1" d="M15.995 6.9a5.996 5.996 0 00-11.99 0H4v11.2h12V6.9h-.005zM15 17.1H5V7.205l.005-.288C5.049 4.206 7.29 2 10 2s4.951 2.206 4.995 4.917l.005.221V17.1z"/>'
  }
})
